// src/components/layout/MainLayout.jsx
import { Outlet, useLocation } from 'react-router-dom';
import AdminHeader from './AdminHeader';
import Footer from './Footer';

const AdminLayout = () => {
    const location = useLocation();
  return (
    <div className="flex flex-col min-h-screen pb-40">
      <AdminHeader />
      <main className=" mt-10  flex-grow">
        <Outlet />
      </main>
    {location.pathname !== '/viewcusproject' && <Footer />}
    </div>
  );
};

export default AdminLayout;
